"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _default = function _default(component) {
  var propTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : component.propTypes;

  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant.default)(!!propTypes, "passthroughProps: expected propTypes object as second argument, got " + propTypes);
  }

  var _ref = typeof component === 'string' ? [component, undefined] : [(0, _getComponentName.default)(component.CoreComponent || component), component],
      _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      name = _ref2[0],
      Component = _ref2[1];

  var validator = function validator() {
    return _propTypes.default.object.apply(_propTypes.default, arguments);
  };

  return (0, _createChainablePropType.default)(validator, 'passthroughProps', {
    Component: Component,
    name: name,
    propTypes: propTypes
  });
};

exports.default = _default;
module.exports = exports.default;